@layer module {
.account-button-styled {
            max-width: 100%;
    }

.account-button-styled .loading {
            width: 100%;
            display: flex;
            justify-content: center;
    }

.account-styled :global(.custom-option-wrapper) {
            display: flex;
            flex-flow: column nowrap;
    }

.add-button-wrapper {
            display: flex;
            justify-content: center;
    }

.add-button-inner {
            display: flex;
            align-items: center;
            cursor: pointer;
    }

.select-account {
            width: 100%;
    }

:where(.select-account).static :global(.select-input__control) {
            cursor: default;
    }
} // layer module










@layer app {
.account-button-styled {
            min-height: $size-44;
            padding: $size-10 $size-18 $size-10 $size-10;
            gap: $size-15;
    }

.account-button-styled.bordered {
            margin-bottom: $size-20;
    }

.account-button-styled.compact {
            height: $size-40;
            min-height: $size-40;
            padding-top: 0;
            padding-bottom: 0;
    }

.select-account-error {
            margin-left: $size-25;
    }

.add-button-wrapper {
            margin: $size-10 $size-30;
    }

.add-button-inner {
            gap: $size-10;
    }

.select-account.bordered {
            margin-bottom: $size-20;
    }

:where(.select-account).compact :global(.select-input__control) {
            height: $size-40;
            min-height: $size-40;
    }

.account-button-styled.bordered {
            border: 1px solid var(--border-neutral-light);
            box-shadow: none;
    }

.account-button-styled.compact {
            background-color: var(--control-surface-bg);
            border: 1px solid var(--control-surface-border-color);
            box-shadow: var(--control-surface-shadow);
            color: var(--control-surface-text-color);
            font-size: var(--font-size-base);
            font-weight: 400;
    }

.account-button-styled .content {
            font-size: var(--font-size-base);
    }

:where(.account-button-styled) .content:global(.recipient) {
            color: var(--custom-selector-content);
    }

.account-button-styled .no-account {
            color: var(--banky-nepal);
    }

.account-styled :global(.custom-option-wrapper) {
            color: var(--custom-selector-content);
            font-size: var(--font-size-base);
            font-weight: normal;
            line-height: $size-17;
    }

.static :global(.select-input__single-value) {
            color: var(--select-option-text);
    }
} // layer app










@layer context {
:global(.filter-pill) .select-account {
            min-width: $size-180;
    }

:global(.filter-pill) .account-button-styled {
            height: $size-34;
            min-height: 0;
            padding: 0;
            gap: $size-6;
    }

:global(.account-form) .account-button-styled:global(.static) {
            box-shadow: none;
    }

:global(.account-form) .content {
            color: var(--banky-nepal);
            font-size: var(--font-size-xs);
    }

:global(.statement-form) .account-button-styled {
            border: 1px solid var(--input-container-border);
            box-shadow: none;
    }

:global(.transactions-header) :global(.select-account-wrapper) {
            width: 100%;
    }

      @media (min-width: 540px) {
                :global(.transactions-header) :global(.select-account-wrapper) {
                        width: $size-350;
                    }
          }

} // layer context
